<ng-template #vcr>
</ng-template>
<div #content>
  <ng-content></ng-content>
</div>
